import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { PregnancyDiagnosisController } from 'src/controllers/pregnancy-diagnosis.controller'
import { SaveDiagnosisWithBirthParams } from 'src/services/api/pregnancy-diagnosis.service'

const pregnancyDiagnosisController = new PregnancyDiagnosisController()

export function useUpdateDiagnosisWithBirth() {
  const { userFarm: farmId, username } = useAuth()

  return useMutation({
    mutationKey: ['updateDiagnosisWithBirth'],
    mutationFn: (diagnosis: SaveDiagnosisWithBirthParams) =>
      pregnancyDiagnosisController.updateDiagnosisWithBirth(farmId!, diagnosis, username!),
    onError: () => {
      toast.error('Erro ao atualizar diagnóstico com nascimento')
    }
  })
}
